module.exports = __webpack_public_path__ + "footer_image-8f322757e09877eb5323e7c1d43e5e92.png";